<template>
  <b-modal
    ref="modal"
    static
    :visible="show"
    :title="modalTitle"
    header-bg-variant="light"
    @hidden="resetForm"
    @close="close"
    @cancel="close"
    @ok.prevent="handleSubmit"
    :ok-disabled="isSubmitting || isDeleting"
    no-close-on-backdrop
    centered
    body-class="px-2 py-5"
    header-class="px-5 py-4"
    footer-class="px-2 py-3"
  >
    <b-form
      @submit.prevent="handleSubmit"
      ref="form"
    >
      <b-col>
        <b-row>
          <b-col cols="6">
            <b-form-group
              class="required-control"
              :state="isValidName"
              :invalid-feedback="nameInvalidFeedback"
            >
              <label>Tên loại khách hàng:</label>
              <b-form-input
                v-model="form.name"
                :state="isValidName"
                required
                placeholder="Nhập tên loại khách hàng"
                maxlength="100"
                :disabled="isSubmitting || isDeleting"
                size="sm"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              :state="isValidCode"
              :invalid-feedback="codeInvalidFeedback"
            >
              <label>Mã loại:</label>
              <b-form-input
                v-model="form.code"
                :state="isValidCode"
                placeholder="Nhập mã loại khách hàng"
                maxlength="20"
                :disabled="isSubmitting || isDeleting"
                size="sm"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              v-if="isEdit"
              label="Trạng thái:"
            >
              <b-form-select
                v-model="form.isActive"
                :options="statusOptions"
                :disabled="isSubmitting || isDeleting"
                size="sm"
                class="select-style"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-form>

    <template #modal-footer="{ cancel }">
      <b-button
        v-if="isEdit"
        variant="danger"
        :disabled="isDeleting"
        @click="handleDelete"
        class="mr-auto"
      >
        <b-spinner
          small
          v-if="isDeleting"
          class="mr-1"
        ></b-spinner>
        Xóa
      </b-button>

      <b-button
        variant="secondary"
        :disabled="isSubmitting || isDeleting"
        @click="cancel()"
      >
        Hủy bỏ
      </b-button>
      <b-button
        variant="primary"
        :disabled="isSubmitting || !isFormValid || isDeleting"
        @click="handleSubmit"
      >
        <b-spinner
          small
          v-if="isSubmitting"
          class="mr-1"
        ></b-spinner>
        {{ isEdit ? 'Cập nhật' : 'Thêm mới' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {  makeToastSuccess } from '@/utils/common';
import { CustomerTypeService } from './service/customer-type.service';

export default {
  name: 'CustomerTypeFormModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    customerType: {
      type: Object,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSubmitting: false,
      isDeleting: false,
      form: {
        name: '',
        code: '',
        isActive: true,
      },
      validationErrors: {
        name: '',
        code: '',
      },
      statusOptions: [
        { value: true, text: 'Đang hoạt động' },
        { value: false, text: 'Ngưng hoạt động' },
      ],
    };
  },
  computed: {
    modalTitle() {
      return this.isEdit
        ? `Chỉnh sửa loại khách hàng: ${this.customerType?.name || ''}`
        : 'Thêm mới loại khách hàng';
    },
    isValidName() {
      return this.validationErrors.name ? false : null;
    },
    isValidCode() {
      return this.validationErrors.code ? false : null;
    },
    nameInvalidFeedback() {
      return this.validationErrors.name;
    },
    codeInvalidFeedback() {
      return this.validationErrors.code;
    },
    isFormValid() {
      return !!this.form.name.trim() && !!this.form.code.trim();
    },
  },
  watch: {
    customerType(newVal) {
      if (newVal) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() {
      if (this.customerType) {
        this.form = {
          name: this.customerType.name || '',
          code: this.customerType.code || '',
          isActive: this.customerType.isActive !== undefined ? !!this.customerType.isActive : true,
        };
      }
    },
    resetForm() {
      this.form = { name: '', code: '', isActive: true };
      this.validationErrors = { name: '', code: '' };
    },
    validateForm() {
      this.validationErrors = { name: '', code: '' };

      if (!this.form.name.trim()) {
        this.validationErrors.name = 'Tên loại khách hàng không được để trống';
      }

      if (!this.form.code.trim()) {
        this.validationErrors.code = 'Mã loại khách hàng không được để trống';
      }

      return !this.validationErrors.name && !this.validationErrors.code;
    },
    close() {
      this.$emit('close');
    },
    handleSubmit() {
      if (!this.validateForm()) return;

      this.isSubmitting = true;

      const formData = {
        name: this.form.name.trim(),
        code: this.form.code.trim(),
        isActive: this.form.isActive,
      };

      const request = this.isEdit
        ? CustomerTypeService.update(this.customerType.id, formData)
        : CustomerTypeService.create(formData);

      request
        .then(response => {
          const message = this.isEdit
            ? 'Cập nhật loại khách hàng thành công!'
            : 'Thêm mới loại khách hàng thành công!';
          makeToastSuccess(message);
          this.$emit('customer-type-saved', response.data.data);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    handleDelete() {
      this.$swal
        .fire({
          title: 'Xóa loại khách hàng!',
          text: `Bạn có chắc muốn xóa loại khách hàng "${this.customerType.name}" này không?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Xóa',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        })
        .then(result => {
          if (result.isConfirmed) {
            this.deleteCustomerType();
          }
        });
    },
    deleteCustomerType() {
      this.isDeleting = true;

      CustomerTypeService.delete(this.customerType.id)
        .then(response => {
          const message = response.data.message || 'Xóa loại khách hàng thành công!';
          makeToastSuccess(message);
          this.$emit('customer-type-saved');
        })
        .finally(() => {
          this.isDeleting = false;
        });
    },
  },
};
</script>

<style scoped>
.required-control label {
  font-weight: 600;
}
</style>
